import React from 'react';
import './Period.css';

function Period() {
  return <div className="period">Period: 1/3</div>;
}

export default Period;
